module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/kayak-a55a15f9c422fa5b7cd927cf0e0395f9.png";